import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import { EqualHeightElement } from "react-equal-height/clean";
import { CarouselCardSvod } from "../../package-carousel.props";
import { MBL_SIZE, TBL_SIZE } from "@directv-digital/dds.ui.dtv-theme";
import CardMedia from "@mui/material/CardMedia";

export interface CardSvodsSectionProps {
  svods: CarouselCardSvod[];
}

const CardSvodsSection = (props: CardSvodsSectionProps) => {
  const { svods } = props;

  try {
    return (
      <DtvBox
        sx={{
          p: "0 16px 12px 16px"
        }}
      >
        <EqualHeightElement name="card-svods-section">
          <DtvBox
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "8px"
            }}
          >
            {svods?.map(
              (svod, index) => !svod?.disable &&
                svod?.name &&
                svod?.logo && (
                  // index key on purpose: real CMS data can repeat svod codes
                  // within one card, so svod.code is not a unique key
                  <picture
                    key={index}
                    style={{
 maxWidth: "64px",
maxHeight: "64px"
}}
                  >
                    <source
                      media={MBL_SIZE}
                      srcSet={svod?.logo?.mobile || svod?.logo?.default}
                    />
                    <source
                      media={TBL_SIZE}
                      srcSet={svod?.logo?.tablet || svod?.logo?.default}
                    />
                    <CardMedia
                      component="img"
                      loading={"eager"}
                      src={svod?.logo?.default}
                      sx={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "2px",
                        objectFit: "contain",
                        display: "block"
                      }}
                      alt={svod?.name || "streaming service"}
                      onError={e => {
                        console.error(
                          `[PackageCarousel][EmbeddedSvodImage] untracked icon error for index ${index}`,
                          e
                        );
                      }}
                    />
                  </picture>
                )
            )}
          </DtvBox>
        </EqualHeightElement>
      </DtvBox>
    );
  } catch (error) {
    return <ErrorDisplay component="CardSvodsSection" error={error} />;
  }
};

export default React.memo(CardSvodsSection);
